import cx from 'classnames';
import { ElementType } from 'react';
import css from './IconButton.module.scss';

interface IconButtonProps {
  className?: string;
  color: 'red' | 'blue';
  icon: ElementType;
  onClick: () => void;
}

export const IconButton = ({
  className,
  color,
  icon: Icon,
  onClick,
}: IconButtonProps) => (
  <button
    className={cx(css.removeButton, css[color], className)}
    onClick={onClick}
  >
    <Icon height={16} width={16} />
  </button>
);
